import { FontFamily } from '@blocksuite/affine-model';

export const GROUP_TITLE_FONT = FontFamily.Inter;
export const GROUP_TITLE_FONT_SIZE = 12;
export const GROUP_TITLE_PADDING = [2, 0];
export const GROUP_TITLE_OFFSET = 4;
